import React from 'react';
import styled from 'styled-components';
import CollapseText from '@catalogo/theme-collapse-text';

const AnswerBox = ({ answer }) => {
  const metric = {
    category: 'product',
    action: 'Q&A - Collapse Text',
  };

  return (
    <Wrapper>
      <Answer>
        <CollapseText
          text={answer.text}
          maxTextLength={159}
          defaultTextHeight={57}
          shouldDispatchMetrics={true}
          metric={metric}
        />
      </Answer>
      <AnswerOwner>respondido por {answer.owner}</AnswerOwner>
      <AnswerCreatedAt>{answer.createdAt}</AnswerCreatedAt>
    </Wrapper>
  );
};

const AnswerOwner = styled.span`
  display: flex;
  margin: 7px 0 0px;
  color: #c4c4c4;
`;

const AnswerCreatedAt = styled.span`
  color: #c4c4c4;
`;

const Answer = styled.p`
  color: #838383;
`;

const Wrapper = styled.div`
  font-size: 13px;
  word-break: break-word;
  margin-left: 8px;
  background: #f8f8f8;
  padding: 18px 15px 18px 20px;
  position: relative;
  border-radius: 0px 5px 5px 0px;

  ::before {
    content: '';
    top: 0px;
    left: -8px;
    width: 3px;
    height: 100%;
    background: #666;
    position: absolute;
  }
`;

export default AnswerBox;
